module.exports = __webpack_public_path__ + "static/story1-index-thumbnails-1920x1080-1356b9ae5b280fa40c1e0f0142e2b8fb.jpg";